<div class="modal-header">
  <h5 class="modal-title">
    <i class="fal fa-sticky-note"></i>&nbsp;&nbsp;
    <ng-container *ngIf="isEdit" i18n> Edit Comment</ng-container>
    <ng-container *ngIf="!isEdit" i18n> Add Comment</ng-container>
  </h5>
  <button (click)="close()" type="button" class="close">
    <i class="far fa-times"></i>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="form" [formEditablePermission]="form">
    <mat-form-field2 [showLabel]="false">
      <textarea
        matInput
        #notes
        [maxlength]="maxLength"
        rows="8"
        formControlName="note"
        i18n-placeholder
        placeholder="Type your comment here.."
        style="outline: none"
      ></textarea>
      <mat-error *ngIf="form.get('note').touched && form.get('note').hasError('required')">
        <ng-container i18n>Comment is required</ng-container>
      </mat-error>
      <mat-hint align="end">{{ notes.value.length }} / {{ maxLength }}</mat-hint>
    </mat-form-field2>
  </form>
</div>
<div class="modal-footer">
  <button
    *ngIf="isEdit"
    (click)="remove()"
    [disabled]="1 | isReadonlyRole"
    type="button"
    class="btn btn-secondary-danger"
  >
    <i class="cs-icon cs-icon-trash"></i> <ng-container i18n>delete</ng-container>
  </button>
  <button (click)="close()" type="button" class="btn btn-light">
    <i class="far fa-times"></i> <ng-container i18n>Cancel</ng-container>
  </button>
  <button (click)="save(form)" type="button" [disabled]="1 | isReadonlyRole" class="btn btn-secondary-info create-btn">
    <i class="cs-icon cs-icon-save"></i> <ng-container i18n>save</ng-container>
  </button>
</div>
